import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "utils";

const initialState = {
  isLoading: false,
  unreadNotificationCount: 0,
  filter: [],
  list: [],
  pagination: {
    page: 1,
    pageSize: 20,
    hasMore: false,
    lastSeqManagerAlarmSendHistory: null,
  },
  fromTop: 0,
  error: null,
};

export const fetchNotifications = createAsyncThunk(
  "notifications/fetchNotifications",
  async (payload, { getState, rejectWithValue }) => {
    try {
      const { pagination, filter } = getState().notifications;
      const { data } = await api.post(`/alarm/history`, {
        criteria: {
          page: pagination.page,
          pageSize: 20,
        },
        lastSeqManagerAlarmSendHistory:
          pagination.lastSeqManagerAlarmSendHistory,
        alarmTypes: filter,
      });
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const readNotifications = createAsyncThunk(
  "notifications/readNotifications",
  async () => {
    try {
      await api.patch(`/alarm/history/read`);
      return;
    } catch (error) {
      console.log(error);
    }
  },
);

const notifications = createSlice({
  name: "notifications",
  initialState,
  reducers: {
    fetchUnreadNotificationsSuccess: (state, action) => {
      state.unreadNotificationCount = action.payload;
    },

    setFilter: (state, action) => {
      state.filter = action.payload;
    },

    setPagination: (state, action) => {
      state.pagination = Object.assign(state.pagination, action.payload);
    },

    setList: (state, action) => {
      state.list = action.payload;
    },

    setFromTop: (state, action) => {
      state.fromTop = action.payload;
    },

    fetchNotificationDataFail: (state, action) => {
      state.error = action.payload;
    },

    resetNotifications: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchNotifications.pending, (state, action) => {
        const { isReset, filter } = action.meta.arg;
        if (isReset) {
          Object.assign(state, {
            ...initialState,
            isLoading: true,
            filter: filter,
          });
        } else {
          state.isLoading = true;
          state.pagination.page = state.pagination.page + 1;
        }
      })
      .addCase(fetchNotifications.fulfilled, (state, action) => {
        const { page } = action.payload;
        if (page.page === 1) {
          state.pagination = {
            ...state.pagination,
            lastSeqManagerAlarmSendHistory:
              page.results[0]?.seqManagerAlarmSendHistory,
          };
        }
        state.pagination = {
          ...state.pagination,
          hasMore: page.last ? false : true,
        };
        state.list =
          page.page === 1 ? page.results : state.list.concat(page.results);
        state.isLoading = false;
      })
      .addCase(fetchNotifications.rejected, (state, action) => {
        state.isLoading = false;
      });
  },
});

export const {
  fetchUnreadNotificationsSuccess,
  setFilter,
  setPagination,
  setList,
  setFromTop,
  fetchNotificationDataFail,
  resetNotifications,
} = notifications.actions;

export const checkForNewNotifications = () => async (dispatch) => {
  try {
    const seqManagerMobile = window.localStorage.getItem("seqManagerMobile");
    if (!seqManagerMobile) return 0;
    await api.get(`/alarm/history/count`).then(({ data }) => {
      dispatch(fetchUnreadNotificationsSuccess(data));
    });
  } catch (error) {
    console.log(error);
    dispatch(fetchNotificationDataFail(error.message));
  }
};

export default notifications.reducer;
